import { createContext } from "react";

const CommonContext = createContext({});

export default CommonContext;